import { render, staticRenderFns } from "./dimensionList.vue?vue&type=template&id=1d976cc3&scoped=true"
import script from "./dimensionList.vue?vue&type=script&lang=js"
export * from "./dimensionList.vue?vue&type=script&lang=js"
import style0 from "./dimensionList.vue?vue&type=style&index=0&id=1d976cc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d976cc3",
  null
  
)

export default component.exports